module.exports = __webpack_public_path__ + "img/report-word-closed.f90b6f0c.png";